import React, { useEffect } from "react";
import { Toaster } from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import L from "leaflet";
import { getMe, setShowPetaJalan } from "./redux/actions";
import { SW_INIT, SW_UPDATE } from "./redux/app/type";
import { isUserAuthenticated } from "./helpers/authUtils";
import Routes from "./routes/Routes";
import AlertUpdateApp from "./components/AlertUpdateApp";
import HierarkiNotFound from "./components/HierarkiNotFound";
import "leaflet-geometryutil";
import "leaflet.awesome-markers/dist/leaflet.awesome-markers";
import "leaflet.awesome-markers/dist/leaflet.awesome-markers.css";
import "nprogress/nprogress.css";
import "easymde/dist/easymde.min.css";
import "react-perfect-scrollbar/dist/css/styles.css";
import "flatpickr/dist/flatpickr.css";
import "leaflet/dist/leaflet.css";
import "./assets/scss/Saas.scss";
import "./assets/css/loading.css";
import "./assets/css/_measure-control.css";

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

const App = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const isLoggin = isUserAuthenticated();

  const {
    serviceWorkerInitialized,
    serviceWorkerUpdated,
    serviceWorkerRegistration,
  } = useSelector((state) => state.App);

  const authState = useSelector((state) => state.Auth);

  const updateServiceWorker = () => {
    const registrationWaiting = serviceWorkerRegistration.waiting;

    if (registrationWaiting) {
      registrationWaiting.postMessage({ type: "SKIP_WAITING" });

      registrationWaiting.addEventListener("statechange", (e) => {
        if (e.target.state === "activated") {
          window.location.reload();
        }
      });
    }
  };

  useEffect(() => {
    dispatch(setShowPetaJalan(false));
  }, []);

  useEffect(() => {
    if (
      !authState.error &&
      !authState.user &&
      !authState.loading &&
      authState.token?.access
    ) {
      dispatch(getMe(history));
    }
  }, [authState.user, authState.loading, authState.token]);

  if (!authState?.loading && isLoggin && !authState?.desa?.hierarki) {
    return <HierarkiNotFound />;
  }

  return (
    <React.Fragment>
      {serviceWorkerInitialized && <AlertUpdateApp type={SW_INIT} />}
      {serviceWorkerUpdated && (
        <AlertUpdateApp type={SW_UPDATE} onClick={updateServiceWorker} />
      )}
      <Routes />
      <Toaster />
    </React.Fragment>
  );
};

export default App;
